import React from 'react';
import { StyledSectionHeader, StyledSectionTitle } from '../../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import { useConditionTitle } from '../tabs/ClinicConditionsTab/useConditionTitle';
import { ClinicCondition } from '../../../types';
import { useCondition } from '../../../../ConditionSelector/useCondition';
import { StyledRow } from '../../../../PlusWebsiteEditor/sections/StatusSection/StatusSection.styled';
import DeleteButton from '../ClinicConditionEditor/DeleteButton';
import ClickablePaper from '../tabs/ClinicConditionsTab/ClickablePaper.styled';
import useClinicById from '../../hooks/useClinicById';
import styled from 'styled-components';

interface ClinicConditionViewerProps {
  clinicCondition?: ClinicCondition | null;
  onEditClick: () => void;
  onDeleteClick: () => void;
  hasError?: boolean;
  currentClinicId?: string;
}

const ClinicConditionViewer = ({ clinicCondition, onEditClick, onDeleteClick, hasError, currentClinicId }: ClinicConditionViewerProps) => {
  const { condition } = useCondition(clinicCondition?.condition_id);
  const title = useConditionTitle(condition);
  const { clinic } = useClinicById(clinicCondition?.clinic_id || '');
  const isFromAnotherClinic = Boolean(clinicCondition?.clinic_id && clinicCondition.clinic_id !== currentClinicId);

  return (
    <ClickablePaper $showRedBorder={hasError} onClick={onEditClick}>
      <StyledSectionHeader>
        <div>
          <StyledSectionTitle>{title}</StyledSectionTitle>
          {isFromAnotherClinic && clinic && (
            <ClinicPill>
              {clinic.name}
            </ClinicPill>
          )}
        </div>
        <ActionButtons onDeleteClick={onDeleteClick} />
      </StyledSectionHeader>
    </ClickablePaper>
  );
};

interface ActionButtonsProps {
  onDeleteClick: ClinicConditionViewerProps['onDeleteClick'];
}

const ActionButtons = ({ onDeleteClick }: ActionButtonsProps) => {
  return (
    <StyledRow>
      <DeleteButton onClick={onDeleteClick} />
    </StyledRow>
  );
};

export default ClinicConditionViewer;

const ClinicPill = styled.div`
  background-color: #2f9d6d;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  display: inline-block;
  margin-top: 8px;
  font-size: 16px;
  font-weight: 600;
`;
